import React from 'react';
import { Chip } from '@mui/material';
import type { ChangeType } from '../../types/changeDetection.types';

interface ChangeTypeBadgeProps {
  type: ChangeType;
  size?: 'small' | 'medium';
}

const changeTypeConfig: Record<ChangeType, {
  color: 'primary' | 'secondary' | 'error' | 'success' | 'warning' | 'info' | 'default';
  label: string;
}> = {
  META: {
    color: 'info',
    label: 'Meta Tags'
  },
  CANONICAL: {
    color: 'secondary',
    label: 'Canonical'
  },
  INDEXABILITY: {
    color: 'error',
    label: 'Indexability'
  },
  CONTENT: {
    color: 'success',
    label: 'Content'
  },
  TEMPLATE: {
    color: 'warning',
    label: 'Template'
  },
  SCHEMA: {
    color: 'primary',
    label: 'Schema'
  }
};

export const ChangeTypeBadge: React.FC<ChangeTypeBadgeProps> = ({ type, size = 'medium' }) => {
  const config = changeTypeConfig[type];

  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      sx={{ fontWeight: 500 }}
    />
  );
};
